/* Product page - "same name on other apps" cross-sell, add-all, preview modal.
   Every tile shows its own listed price: no bundle pricing, no free item and no
   percentage, because Google Merchant Center forbids promotional bundling. */
(function () {
  'use strict';
  // Euros (already decimal) to the store's money format (€1.234,56), which is
  // what the checkout charges.
  function money(euros) {
    return fmt(Number(euros));
  }
  function fmt(v) {
    var parts = v.toFixed(2).split('.');
    return '\u20AC' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }
  var PLAT = {
    instagram: '<svg viewBox="0 0 24 24" fill="none"><rect x="6" y="6" width="12" height="12" rx="4" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="17" cy="7" r="1.1" fill="currentColor"/></svg>',
    tiktok: '<svg viewBox="0 0 24 24"><path d="M15.2 6.2c.4 1.3 1.4 2.3 2.7 2.6v2.1c-1-.02-1.9-.3-2.7-.8v3.9a3.9 3.9 0 1 1-3.9-3.9c.2 0 .3 0 .5.02v2.1a1.85 1.85 0 1 0 1.3 1.77V6.2h2.1z" fill="currentColor"/></svg>',
    telegram: '<svg viewBox="0 0 24 24"><path d="M6 11.8l10.2-3.94c.47-.17.88.11.73.83l-1.74 8.2c-.12.56-.46.7-.93.44l-2.56-1.89-1.24 1.19c-.14.14-.25.25-.5.25l.18-2.6 4.73-4.27c.2-.18-.05-.28-.32-.1L7.6 12.6l-2.52-.79c-.55-.17-.56-.55.12-.81z" fill="currentColor"/></svg>',
    twitter: '<svg viewBox="0 0 24 24"><path d="M6.6 6h3.4l3 4.1L16.6 6h1.9l-4.6 5.3L19 18h-3.4l-3.2-4.4L8.6 18H6.7l4.9-5.7L6.6 6z" fill="currentColor"/></svg>',
    discord: '<svg viewBox="0 0 24 24"><path d="M16.4 7.3a10.5 10.5 0 0 0-2.6-.8l-.12.25a9.7 9.7 0 0 1 2.36.9 8 8 0 0 0-8.08 0 9.7 9.7 0 0 1 2.36-.9L10.2 6.5a10.5 10.5 0 0 0-2.6.8C6.06 9.6 5.64 11.83 5.85 14a10.6 10.6 0 0 0 3.2 1.6l.66-1.06a6.5 6.5 0 0 1-1.04-.5l.26-.2a7.5 7.5 0 0 0 6.14 0l.26.2c-.33.2-.68.37-1.04.5l.66 1.06a10.6 10.6 0 0 0 3.2-1.6c.25-2.5-.42-4.68-1.75-6.7zM9.9 12.7c-.62 0-1.13-.57-1.13-1.27s.5-1.27 1.13-1.27c.63 0 1.14.57 1.13 1.27 0 .7-.5 1.27-1.13 1.27zm4.2 0c-.62 0-1.13-.57-1.13-1.27s.5-1.27 1.13-1.27c.63 0 1.14.57 1.13 1.27 0 .7-.5 1.27-1.13 1.27z" fill="currentColor"/></svg>',
    snapchat: '<svg viewBox="0 0 24 24"><path d="M12 5.4c1.9 0 3.1 1.5 3.15 3.3.02.5-.03 1 .02 1.3.1.2.5.2.8.1.35-.1.6.1.6.35 0 .3-.45.45-.8.6-.28.12-.5.25-.45.55.15.9 1.2 1.65 2 1.85.25.06.35.25.28.45-.15.42-1.05.6-1.4.66-.1.02-.16.14-.18.28-.02.14-.05.34-.3.34-.4 0-.9-.28-1.65-.06-.6.18-1.15.9-2.34.9s-1.7-.72-2.34-.9c-.75-.22-1.25.06-1.65.06-.25 0-.28-.2-.3-.34-.02-.14-.08-.26-.18-.28-.35-.06-1.25-.24-1.4-.66-.07-.2.03-.39.28-.45.8-.2 1.85-.95 2-1.85.05-.3-.17-.43-.45-.55-.35-.15-.8-.3-.8-.6 0-.25.25-.45.6-.35.3.1.7.1.8-.1.05-.3 0-.8.02-1.3C8.9 6.9 10.1 5.4 12 5.4z" fill="currentColor"/></svg>',
  };
  function tile(it) {
    return '<div class="ni-pdp__tile">' +
      '<span class="ni-plat" role="img" aria-label="' + it.platformLabel + '">' + (PLAT[it.platform] || '') + '</span>' +
      '<span class="ni-pdp__tilename"><span class="ni-accent">' + it.prefix + '</span>' + it.name + '</span>' +
      '<span class="ni-pdp__tileprice">' + money(it.price) + '</span></div>';
  }
  function addAll(ids) {
    var items = ids.filter(Boolean).map(function (id) { return { id: Number(String(id).split('/').pop()), quantity: 1 }; });
    if (!items.length) return;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function () { window.location.href = '/cart'; });
  }

  /* ---- Same name on other apps (plain cross-sell, full price) ---- */
  var cross = document.querySelector('[data-ni-cross]');
  if (cross) {
    var items = JSON.parse(cross.getAttribute('data-items'));
    cross.querySelector('[data-cross-tiles]').innerHTML = items.map(tile).join('');
    cross.querySelector('[data-cross-add]').addEventListener('click', function () {
      addAll(items.map(function (i) { return i.variantId; }));
    });
  }

  /* ---- Preview modal ---- */
  var modal = document.querySelector('[data-ni-preview-modal]');
  var openBtn = document.querySelector('[data-ni-preview]');
  if (modal && openBtn) {
    function close() { modal.hidden = true; }
    openBtn.addEventListener('click', function () { modal.hidden = false; });
    modal.querySelectorAll('[data-pv-close]').forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }
})();
